import { Injectable } from '@angular/core'
import { HttpHeaders } from '@angular/common/http'
import { Observable, ReplaySubject } from 'rxjs'
import { ApiService } from '../../../core/services/api/api.service'
import { ApiGetInterface, ApiPatchInterface, ApiPostInterface } from '@core/models/apiServiceInterface.interface'
import { SmbUser, UserUpdatePayload } from '../models/profiles.interface'
@Injectable({
  providedIn: 'root',
})
export class ProfilesService {
  private profilePicUpload = new ReplaySubject<boolean>(1)
  profilePicUpload$ = this.profilePicUpload.asObservable()

  constructor(private apiService: ApiService) {}

  getUserInfo(): Observable<SmbUser> {
    const apiRequest: ApiGetInterface = {
      url: `admin/users/self`,
    }
    return this.apiService.get(apiRequest)
  }

  updateUser(userObj: UserUpdatePayload): Observable<SmbUser> {
    const apiRequest: ApiPatchInterface = {
      url: 'admin/smb/users',
      data: userObj,
    }
    return this.apiService.patch(apiRequest)
  }

  uploadProfileImage(data: FormData): Observable<SmbUser> {
    const headersConfig = new HttpHeaders({
      'With-Auth': 'true',
      Accept: '*/*',
    })
    const apiRequest: ApiPostInterface = {
      url: `admin/smb/users/avatar`,
      data: data,
      header: headersConfig,
    }
    return this.apiService.post(apiRequest)
  }

  deleteProfileImage(){
      const apiRequest: ApiPostInterface = {
        url: `admin/smb/users/avatar`,
        data: {},
      }
      return this.apiService.delete(apiRequest)
  }
}
